import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(async () => {
    const paymentCalculatorStore = usePaymentCalculatorStore()
    const domainStore = useDomainStore()

    if (domainStore.payments.enabled && !paymentCalculatorStore.taxRate) {
        await paymentCalculatorStore.getTaxRate()
    }
})
